import React, {} from 'react';
import Popup from "reactjs-popup";

const ShowTimeLineAlert_Popup = ({_WaveformView}) => {
//網址判斷
//     useEffect(() => {
//
//     }, [location]);

    return <Popup
        open={_WaveformView.state.isShowTimeLineAlert}
        modal
        closeOnDocumentClick
        onClose={()=>{
            _WaveformView.setState({isShowTimeLineAlert:false });
        }}
        contentStyle={{width:'600px',padding:'20px'}} >
        <div>
            <h3>Go To Timeline</h3>
            <p>Please enter the timecode to navigate to the timeline position: </p>

            <div className="form-row align-items-center">
                <div className="row">
                    <div className="col-2">

                        <input className="col-12"
                               onChange={event =>{
                                   _WaveformView.hour = event.target.value;
                               }}  />
                    </div>:

                    <div className="col-2">

                        <input className="col-12"
                               onChange={event =>{
                                   _WaveformView.Minute = event.target.value;
                               }}　 />
                    </div>:

                    <div className="col-2">

                        <input className="col-12"
                               onChange={event =>{
                                   _WaveformView.second = event.target.value;
                               }}/>
                    </div>:

                    <div className="col-2">

                        <input className="col-12"
                               onChange={event =>{
                                   _WaveformView.fram = event.target.value;
                               }} />
                    </div>
                </div>
                <div className="col-auto mt-4">
                    <button type="submit"  className="btn  btn-secondary btn-sm mb-2" onClick={()=>{
                        _WaveformView.editTransaction();
                        _WaveformView.setState({isShowTimeLineAlert:false,isShowTranslationsNavbarAlert:false });
                    }} >Go</button>
                </div>
            </div>
        </div>
    </Popup> ;
};

export default ShowTimeLineAlert_Popup;



// WEBPACK FOOTER //
// ./src/components/popup/ShowTimeLineAlert_Popup.js